import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { Porcentajes } from "./porcentajes";

type Entity = models.TarifaPagoChofer;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un TarifaPagoChofer
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { 
        Nombre: validation.required,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class TarifaPagoChoferFormNoRx extends React.PureComponent<Props> {
constructor(props) {
    super(props);
}

    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Porc = getField(Porcentajes);
        return (
            <div>
                <kea.Title titulo="Tarifa de pago a proveedor" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" />,
                ])}

                <Porc field="Porcentajes" />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const TarifaPagoChoferForm = componentToRx(TarifaPagoChoferFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapagochofer/edit/form.tsx